export default {
  SET_SHIPHERO_RESULTS(state, payload) {
    state.shipHeroShipmentResults = payload;
  },
  setQuickEditActive(state, isActive) {
    state.quickEditActive = isActive;
  },

  UPDATE_SHIP_HERO_STATUS(state){
    state.shipHeroDataExists = true;
  },

  RESET_SHIP_HERO_STATUS(state){
    state.shipHeroDataExists = false;
  }
};
